import * as SettingsTypes from '../../actions/settings/types';

export function settingsReducer(state = {}, action) {
    switch (action.type) {
        case SettingsTypes.SET_SOUND_ENABLED:
            return {
                ...state,
                soundEnabled: action.payload,
            };

        case SettingsTypes.SET_NOTIFICATIONS_ENABLED:
            return {
                ...state,
                realtimeEnabled: action.payload,
            };
        default:
            return state;
    }
}
